import React, { useRef, useState, useEffect } from 'react';
import imageCompression from 'browser-image-compression';

const NewFileUploader = ({
    onChange,
    documentUploadUrl = null,
    documentUrlData,
    multiple = false,
    accept = 'image/*',
    id,
    value = '',
    isBase64 = false,
    capture = true,
    isPublic = false,
    prefilledFilename,
    label,
    required = false,
}) => {
    const inputFile = useRef(null);
    const [fileName, setFileName] = useState(prefilledFilename || '');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (value) {
            const extractedName = value.split('/').pop() || 'Uploaded file';
            setFileName(extractedName);
        } else {
            setFileName('');
        }
    }, [value]);

    const handleFileChange = (event) => {
        let val = event.target.files;
        if (!val) return;

        if (multiple) {
            let fileLength = val.length;
            setIsLoading(true);

            function readAndPreview(file) {
                var options = {
                    maxSizeMB: 20,
                    maxWidthOrHeight: 700,
                    useWebWorker: true
                };

                imageCompression(file, options)
                    .then((compressedFile) => {
                        let reader = new FileReader();
                        reader.onload = async function () {
                            if (documentUploadUrl) {
                                const res = await documentUploadUrl({
                                    base_64_file: this.result,
                                });
                                onChange(res?.file_url);
                                setFileName(`${fileLength} file${fileLength > 1 ? 's' : ''}`);
                                setIsLoading(false);
                            }
                        };
                        reader.readAsDataURL(compressedFile);
                    })
                    .catch(() => {
                        let reader = new FileReader();
                        reader.onload = async function () {
                            if (documentUploadUrl) {
                                const res = await documentUploadUrl({
                                    base_64_file: this.result,
                                });
                                onChange(res?.file_url);
                                setFileName(`${fileLength} file${fileLength > 1 ? 's' : ''}`);
                                setIsLoading(false);
                            }
                        };
                        reader.readAsDataURL(file);
                    });
            }

            [].forEach.call(val, readAndPreview);
        } else {
            let name = val[0].name.replace(/\.[^/.]+$/, '');
            setIsLoading(true);
            let Fl = new FileReader();
            Fl.onload = async () => {
                if (isBase64) {
                    onChange(Fl.result);
                    setFileName(name);
                    setIsLoading(false);
                } else {
                    if (Fl.result && documentUploadUrl) {
                        const res = await documentUploadUrl({ base_64_file: Fl.result });
                        if (res) {
                            onChange(res?.file_url);
                            setFileName(name);
                            setIsLoading(false);
                        }
                    }
                }
            };
            Fl.readAsDataURL(val[0]);
        }
    };

    const handleRemove = () => {
        setFileName('');
        onChange('');
        if (inputFile.current) {
            inputFile.current.value = ''; 
        }
    };

    return (
        <div className="mr-3" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {!fileName && (
                <>
                    <input
                        ref={inputFile}
                        type="file"
                        id={id}
                        accept={accept}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                        required={required}
                    />
                    <label
                        htmlFor={id}
                        style={{
                            display: "inline-block",
                            padding: "8px 12px",
                            backgroundColor: "#5430bb",
                            color: "#fff",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "14px",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {isLoading ? "Uploading..." : label}
                    </label>
                </>
            )}

            {fileName && (
                <div
                    style={{
                        position: "relative",
                        display: "inline-block",
                        marginRight: "8px"
                    }}
                >
                    {value && value.match(/\.(jpeg|jpg|png|gif|webp)$/i) ? (
                        <img
                            src={value}
                            alt="Uploaded"
                            style={{
                                width: "60px",
                                height: "60px",
                                objectFit: "cover",
                                borderRadius: "6px",
                                border: "2px solid #5430bb"
                            }}
                            onClick={() => window.open(value, "_blank")}
                        />
                    ) : (
                        <div
                            style={{
                                width: "60px",
                                height: "60px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "#f0f0f0",
                                borderRadius: "6px",
                                border: "2px solid #5430bb",
                                cursor: "pointer"
                            }}
                            onClick={() => window.open(value, "_blank")}
                        >
                            📄
                        </div>
                    )}

                    <span
                        style={{
                            position: "absolute",
                            top: "-6px",
                            right: "-6px",
                            background: "white",
                            color: "red",
                            borderRadius: "50%",
                            padding: "2px 5px",
                            fontSize: "12px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            boxShadow: "0 0 3px rgba(0,0,0,0.3)"
                        }}
                        onClick={handleRemove}
                    >
                        ✖
                    </span>
                </div>
            )}


        </div>
    );
};

export default NewFileUploader;
